import axiosInstance from "./axios";
import { errorToast } from "../shared/Toast";

/**
 * Platform-wide back-office audit history (API: AuditLogs table).
 *
 * One table for every module — marketing campaigns, wallet card settings, and whatever
 * comes next — read through one endpoint. Filter by `module`, and by `entityType` +
 * `entityId` for one record's history. `entityId` on its own is refused by the API (the id
 * is not a foreign key, so a campaign id and a merchant id can collide).
 *
 * Rows carry previousValues/newValues as a diff of only the keys that moved, `metadata` for
 * non-diff context (job counters, push kind), and `source` = admin | job | api.
 */
export const AUDIT_MODULES = {
  marketing: "marketing",
  wallet: "wallet",
  membership: "membership",
  recommendations: "recommendations",
};

const EMPTY_PAGE = { rows: [], total: 0, page: 1, limit: 20, totalPages: 0 };

const readFail = (error, fallback, message) => {
  errorToast(error?.response?.data?.message ?? error?.message ?? message);
  return fallback;
};

// GET /api/audit-logs?merchantId&module&entityType&entityId&action&source&dateFrom&dateTo&page&limit
export const getAuditLogs = async (params = {}) => {
  try {
    const res = await axiosInstance.get("/api/audit-logs", { params });
    if (res?.data && !res.data.isError) return res.data.data || EMPTY_PAGE;
    errorToast(res?.data?.message ?? "Error loading history");
    return EMPTY_PAGE;
  } catch (error) {
    return readFail(error, EMPTY_PAGE, "Error loading history");
  }
};
